import { LegalInformationType } from '../../../../common/constants';

export const PUBLIC_INFORMATION_ROUTES: ReadonlyArray<{
  path: string;
  type: LegalInformationType;
}> = [
  {
    path: 'termeni-si-conditii',
    type: 'termsAndConditions',
  },
  {
    path: 'politica-prelucrare-date-personale',
    type: 'privacyPolicy',
  },
  {
    path: 'politica-cookies',
    type: 'cookies',
  },
  {
    path: 'accesibilitate',
    type: 'accessibility',
  },
];
